import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Pagination, QueryParams, ResponseData, RootEpic } from "../../common/define-types";
import {filter, switchMap, mergeMap, catchError, map, of, OperatorFunction} from 'rxjs';
import {AjaxError} from 'rxjs/ajax';
import TagAPI, { Tag } from "../../api/Tag.api";
import { set } from "date-fns";

interface TagState {
    loading: boolean;
    TagData: ResponseData<Tag> | null
    errorMessage: string | null;
    isShowHome: boolean;
}

const initState: TagState = {
    loading: false,
    TagData: null,
    errorMessage: null,
    isShowHome: true,
};
const TagSlice = createSlice({
    name: 'Tag',
    initialState: initState,
    reducers: {
        getTag(state, action: PayloadAction<void>) {
            state.loading = true;
        },
        getTagSuccess(state, action: PayloadAction<ResponseData<Tag> | null>) {
            state.loading = false;
            state.TagData = action.payload;
        },
        setIsShowHome(state, action: PayloadAction<boolean>) {
            state.isShowHome = action.payload;
        },
        failRequest(state, action: PayloadAction<string>) {
            state.loading = false;
            state.errorMessage = action.payload;
        },
    }}
);

const Tag$: RootEpic = (action$) =>
    action$.pipe(
        filter(getTag.match),
        switchMap((re) => {
            return TagAPI.get().pipe(
                mergeMap((res) => {
                    return [
                        TagSlice.actions.getTagSuccess(res),
                    ];
                }),
                catchError((e: AjaxError) => [
                    TagSlice.actions.failRequest("Có lỗi xảy ra vui lòng thử lại sau"),
                ]),
            )
        })
)

export const TagEpics = [Tag$];
export const {
    getTag,
    getTagSuccess,
    setIsShowHome
} = TagSlice.actions;
export const TagReducer = TagSlice.reducer;